import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Col, Modal, Row } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import React, { FC, useEffect, useState } from "react";
import { useGetFavoriteAdvertList } from "../ServerSideStates";
import SkeletonCard from "apps/Common/Skelton/AdvertCardSkelton";
import RealStateCardViewItem from "apps/RealState/Common/CardViewIem";
import { resetAllItemsFavoriteList } from "../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import endPoints from "../EndPoints"
import { useQueryClient } from "react-query";
import CustomNoData from "apps/Common/CustomNoData";

interface FavoriteListItemProps {
  favoriteListItem: any;
}

const FavoriteListItem: FC<FavoriteListItemProps> = ({ favoriteListItem }) => {
  const favoriteAdverts = useGetFavoriteAdvertList(favoriteListItem.id);
  console.log("favoriteAdverts", favoriteAdverts)
  const [favoriteAdvertsData,setFavoriteAdvertsData] = useState<any>([])
 const queryClient = useQueryClient()
  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu listede olan tüm ilanlar favoridan kaldırılacaktır.Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          const response = await resetAllItemsFavoriteList(favoriteListItem);
          queryClient.resetQueries({
            queryKey: endPoints.getFavoriteAdvertList,
            exact: false,
          });
          queryClient.resetQueries({
            queryKey: endPoints.getFavoriteListFilter,
            exact: false,
          });
          openNotificationWithIcon("default", response.message);
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);

          console.log("Somethings wrong during login to dashboard", error);
        }
      },
    });
  };

  useEffect(()=>{
    if(favoriteAdverts?.data?.data)
    {
      setFavoriteAdvertsData(favoriteAdverts?.data?.data?.favorite.map((item:any)=>{
        return{
          ...item,
          isFavorite:true
        }
      }))
    }
  },[favoriteAdverts.data])


  return (
    <>
      <Col xs={24} className="!p-0" >
        <Row 
         gutter={[
          { xs: 10, md:10 , xl:10 }, 
          { xs:10 , md: 15, xl:20}   
        ]}
        >
          <Col xs={24} className=" justify-end !hidden lg:!flex">
            <MazakaButton
              icon={<DeleteOutlined className="!text-white " />}
              className="!bg-red-500  !text-xs !p-2 md:!p-4 md:!text-sm  "
              onClick={confirm}
            >
              Tümü Kaldır
            </MazakaButton>
          </Col>
          <Col xs={24}>
            <Row
              gutter={[
                { xs: 10, sm:20, md:25 , lg: 30,xl:35,xxl:40 }, 
                { xs:10 ,sm:20, md: 25, lg: 30,xl:35,xxl:40 }   
              ]}
            >
              <SkeletonCard
                count={4}
                customGutter={[
                  { xs: 10, sm:20, md:25 , lg: 30,xl:35,xxl:40 }, 
                  { xs:10 ,sm:20, md: 25, lg: 30,xl:35,xxl:40 }   
                ]}
                loading={
                  favoriteAdverts.isLoading || favoriteAdverts.isFetching
                }
              >
                <>
                {
                  favoriteAdvertsData?.length>0?<>
                  {

                    favoriteAdvertsData.map(
                      (item: any, index: number) => {
                        return (
                          <React.Fragment key={index}>
                            <Col
                              xs={12}
                              md={12}
                              lg={6}
                              className="hover:cursor-pointer !p-1"
                            >
                              <RealStateCardViewItem
                                item={item?.advert}
                                mainItem={item}
                                data={favoriteAdvertsData}
                                pageType="favorite"
                                setData={setFavoriteAdvertsData}
                                advertType={
                                  item?.advert?.type === 0 ? "realState" : "vehicle"
                                }
                              />
                            </Col>
                          </React.Fragment>
                        );
                      }
                    )
                  }
                  
                  </>:<>
                  <CustomNoData description="Favori İlan Bulunamadı"/>
                  </>
                }
                </>
              </SkeletonCard>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default FavoriteListItem;
